(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(() => {
  const cache = new Map();
  const getSectionHtml = async (button) => {
    const nextUrl = button.dataset.nextUrl;
    if (!nextUrl) return null;
    if (cache.has(nextUrl)) return cache.get(nextUrl);

    const section = button.closest('[data-section-id]');
    const sectionId = section && section.dataset.sectionId;
    if (!sectionId) return null;

    const url = new URL(nextUrl, window.location.origin);
    const currentUrl = new URL(window.location.href);
    const previewThemeId = currentUrl.searchParams.get('preview_theme_id');
    if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
    url.searchParams.set('sections', sectionId);

    const request = fetch(url.toString(), {credentials: 'same-origin'})
      .then((response) => {
        if (!response.ok) throw new Error('Load more request failed');
        return response.json();
      })
      .then((data) => data[sectionId] || null)
      .catch(() => null);

    cache.set(nextUrl, request);
    return request;
  };

  const appendNextPage = async (button) => {
    if (button.dataset.loading === 'true') return;
    button.dataset.loading = 'true';
    button.disabled = true;
    button.textContent = button.dataset.loadingLabel || button.textContent;

    let activeButton = button;
    let appended = 0;

    while (activeButton && activeButton.dataset.nextUrl && appended === 0) {
      const html = await getSectionHtml(activeButton);
      if (!html) break;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('.product-list--collection');
      const currentGrid = document.querySelector('.product-list--collection');
      const nextButton = doc.querySelector('.bf-load-more');
      const nextProgress = doc.querySelector('.bf-load-more-progress');

      if (newGrid && currentGrid) {
        const products = Array.from(newGrid.children);
        appended = products.length;
        products.forEach((product) => currentGrid.appendChild(product));
      }

      const wrap = activeButton.closest('.bf-load-more-wrap');
      const progress = wrap && wrap.querySelector('.bf-load-more-progress');
      if (progress && nextProgress) {
        progress.textContent = nextProgress.textContent;
        progress.dataset.seen = nextProgress.dataset.seen;
        progress.dataset.total = nextProgress.dataset.total;
      }

      if (nextButton) {
        activeButton.dataset.nextUrl = nextButton.dataset.nextUrl;
        cache.delete(activeButton.dataset.nextUrl);
        activeButton.dataset.loading = 'false';
        activeButton.disabled = false;
        activeButton.textContent = nextButton.textContent;
      } else {
        activeButton.remove();
        activeButton = null;
      }
    }

    if (activeButton && appended === 0) {
      activeButton.dataset.loading = 'false';
      activeButton.disabled = false;
      activeButton.textContent = activeButton.textContent;
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.bf-load-more');
    if (!button) return;
    appendNextPage(button);
  });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const button = entry.target;
        getSectionHtml(button);
        observer.unobserve(button);
      });
    }, {rootMargin: '800px 0px'});

    const observe = () => {
      document.querySelectorAll('.bf-load-more').forEach((button) => observer.observe(button));
    };

    observe();
    document.addEventListener('shopify:section:load', observe);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
